






































































































import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import { AppModule } from "@/store/app";
import { getProductListByPage } from "@/axios";

@Component({
  name: "landmarkShop",
})
export default class extends Vue {
  @Prop()
  inputLandmarkShopData: any;

  private img: any = [
    {
      id: 1,
      name: "test",
      url: require("../assets/images/fuguoing1.png"),
    },
    {
      id: 2,
      name: "test",
      url: require("../assets/images/fuguoing2.png"),
    },
    {
      id: 3,
      name: "test",
      url: require("../assets/images/fuguoing5.png"),
    },
    {
      id: 4,
      name: "test",
      url: require("../assets/images/fuguoing4.png"),
    },
    {
      id: 5,
      name: "test",
      url: require("../assets/images/fuguoing3.png"),
    },
  ];

  private landmarkId: any = "";

  private advertisementArray: any = [];
  private id: any;

  private changefuguo(index: any, id: any) {
    // console.log("item.id================", id);
    // alert(1111111);
    AppModule.landMarkIdAc(id);
    this.$router.push({
      path: "/",
    });
  }

  @Watch("inputLandmarkShopData", { immediate: true, deep: true })
  oninputLandmarkShopData(val: any, oldVal: any) {
    // this.landmarkShopData = val;

    // this.enterpriseGoodsArray = val.enterpriseGoodsCount
    // console.log('oninputLandmarkShopData----',val)

    if (val) {
      this.list = val.enterpriseGoodsArray;
      this.listCount = val.enterpriseGoodsCount;
      this.landmarkId = this.$route.query.landmarkId;
      this.advertisementArray = val.AdvertisementArray;
      // this.getData();
    }
  }

  // private enterpriseGoodsArray: any = [];

  // private landmarkShopData:any = {
  //   cityList: [],
  //   enterpriseGoodsArray: [],
  //   goodsGroupArray: [],
  //   advertisementArray: []
  // }

  // private cityItemIndex :any = 0;

  // private citySelected: any = '';

  // private tabCityItemIndex (index:any) {
  //   this.cityItemIndex = index;
  // }
  mounted() {
    this.getData();
  }
  private page: any = 1;
  private page_size: any = 9;
  private area_id: any = "";
  private listCount: any = [];
  private list: any = [];

  private pageChange(page: any) {
    this.page = page;
    this.getData();
  }

  private openUrl(url: any) {
    if (url) {
      window.open(url, "_blank");
    }
  }
  private searchshopevent() {
    getProductListByPage({
      page_size: this.page_size,
      page: this.page,
      landmark_id: this.landmarkId,
      searchName: this.searchName,
    }).then((res: any) => {
      this.listCount = res.data.data.count;
      this.list = res.data.data.data;
      // this.enterpriseGoodsArray = res.data.data.data;
      // console.log('getProductListByPage----------',res)
    });
  }
  private searchName: any = null;
  private getData() {
    getProductListByPage({
      page_size: this.page_size,
      page: this.page,
      landmark_id: this.landmarkId,
      searchName: this.searchName,
    }).then((res: any) => {
      this.listCount = res.data.data.count;
      this.list = res.data.data.data;
      // this.enterpriseGoodsArray = res.data.data.data;
      // console.log('getProductListByPage----------',res)
    });
  }
}
